import { useEffect } from 'react';
import { Asset, WidgetItem, useLoadAsset } from '@facephi/inphinite-common';
import { Spinner } from '@facephi/ui-react';

type IProps = {
  asset: Asset;
  onClick?(): void;
  token?: string;
};

export const ImageLoad = ({ asset, onClick, token }: IProps) => {
  const { resourceUrl, loadingResource, cancelSource, hasError } = useLoadAsset(
    asset.url,
    asset.contentType,
    token,
  );

  useEffect(() => {
    return () => cancelSource();
  }, []);

  return loadingResource ? (
    <Spinner size="S" insideComponent />
  ) : hasError ? (
    <WidgetItem
      iconName="FileX"
      backgroundColor="error"
      size="L"
      direction="column"
      labelSize="14"
      labelColor="error400"
    />
  ) : (
    <img src={resourceUrl} alt={asset.type} onClick={onClick} />
  );
};
